// @flow

const docsSoap = require('./lib/docsSoap');
const parseHTML = require('./lib/parseHTML');

module.exports = {
  default: docsSoap,
  docsSoap: docsSoap,
  parseHTML: parseHTML,
};



//////////////////
// WEBPACK FOOTER
// ./~/docs-soap/index.js
// module id = 907
// module chunks = 0